import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const LS_KEY = 'stratai_settings';

export type SimilarityDisplayMode = 'triplet' | 'average';

interface SettingsState {
    similarityDisplayMode: SimilarityDisplayMode;
    /** Weight of model A (0–1). Weight of model B = 1 − weightA. */
    weightA: number;
}

function loadFromStorage(): SettingsState {
    try {
        const raw = localStorage.getItem(LS_KEY);
        if (raw) return { ...defaultState, ...JSON.parse(raw) };
    } catch {}
    return defaultState;
}

const defaultState: SettingsState = {
    similarityDisplayMode: 'triplet',
    weightA: 0.5,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState: loadFromStorage,
    reducers: {
        setSimilarityDisplayMode(state, action: PayloadAction<SimilarityDisplayMode>) {
            state.similarityDisplayMode = action.payload;
            localStorage.setItem(LS_KEY, JSON.stringify(state));
        },
        setWeightA(state, action: PayloadAction<number>) {
            state.weightA = Math.max(0, Math.min(1, action.payload));
            localStorage.setItem(LS_KEY, JSON.stringify(state));
        },
    },
});

export const { setSimilarityDisplayMode, setWeightA } = settingsSlice.actions;
export default settingsSlice.reducer;
